<template>
    <q-page padding>
        <q-tabs color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab default slot="title" name="feed" :label="$t('messages')" icon="fal fa-envelope" />

            <q-tab-pane name="feed" :style="getStyle">
                <div class="row q-mb-sm">
                    <div class="col-12">
                        <q-search v-model="search" :float-label="$t('search')" :debounce="500" />
                    </div>
                </div>

                <div class="row" v-if="$q.platform.is.mobile">
                    <div class="col-xs-12">
                        <q-card style="height: 70vh;">
                            <q-card-main>
                                <q-scroll-area style="height: 60vh;">
                                    <q-list highlight separator sparse no-border>
                                        <q-item link v-if="messages.length === 0">
                                            <q-item-main :label="$t('no_messages_found')" />
                                        </q-item>

                                        <q-item link v-for="(message, index) in filteredMessages" :key="index" @click.native="fetchMessage(message)" :class="id === message.id ? 'selected' : ''">
                                            <q-item-main :label="message.title" :sublabel="fDate(message.send_date)" />
                                        </q-item>
                                    </q-list>
                                </q-scroll-area>
                            </q-card-main>
                        </q-card>
                    </div>
                </div>

                <div class="row gutter-xs full-height" v-if="$q.platform.is.desktop">
                    <div class="col-sm-4">
                        <q-card class="full-height">
                            <q-card-main class="full-height">
                                <q-scroll-area class="full-height">
                                    <q-list highlight separator sparse no-border>
                                        <q-item link v-if="messages.length === 0">
                                            <q-item-main :label="$t('no_messages_found')" />
                                        </q-item>

                                        <q-item link v-for="(message, index) in filteredMessages" :key="index" @click.native="fetchMessage(message)" :class="id === message.id ? 'selected' : ''">
                                            <q-item-main :label="message.title" :sublabel="fDate(message.send_date)" />
                                        </q-item>
                                    </q-list>
                                </q-scroll-area>
                            </q-card-main>
                        </q-card>
                    </div>

                    <div class="col-sm-8">
                        <q-card class="full-height relative-position">
                            <q-card-main class="full-height">
                                <q-scroll-area class="full-height q-pa-xl">
                                    <span v-html="body"></span>
                                </q-scroll-area>
                            </q-card-main>

                            <q-inner-loading :visible="loading">
                                <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
                            </q-inner-loading>
                        </q-card>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <q-modal v-model="show_message" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="closeMessage()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding relative-position">
                    <div class="row">
                        <div class="col-12">
                            <span v-html="body"></span>
                        </div>
                    </div>

                    <q-inner-loading :visible="loading">
                        <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
                    </q-inner-loading>
                </div>
            </q-modal-layout>
        </q-modal>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { getDateDiff, formatDate } = date

export default {
    i18nOptions: { namespaces: [ "custom", "common"] },

    data() {
        return {
            messages: [],
            title: '',
            send_date: '',
            body: '',
            id: '',
            loading: false,
            show_message: false,
            search: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getStyle() {
            if (this.$q.platform.is.desktop) return 'height: 60vh;'
            else if (this.$q.platform.is.mobile) return 'height: 75vh;'
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        filteredMessages() {
            if (!this.search) return this.messages
            else {
                return this.messages.filter((e) => e.title.toUpperCase().includes(this.search.toUpperCase()))
            }
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_messages/messages/`, this.getHeader)
            .then(response => {
                this.messages = response.data
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        fetchMessage(message) {
            this.title = ''
            this.body = ''
            this.send_date = ''

            if (!this.$q.platform.is.mobile) {
                this.id = message.message_id
                this.loading = true

                if (this.$q.platform.is.mobile) this.show_message = true

                this.$axios.get(`/etraining_messages/messages/${this.id}/`, this.getHeader)
                .then(response => {
                    this.title = response.data.title
                    this.send_date = response.data.send_date
                    this.body = response.data.body
                    this.loading = false
                })
                .catch(e => {
                    this.loading = false
                    console.log(e)
                })
            }
            else if (message.id != this.id) {
                this.id = message.message_id
                this.loading = true

                if (this.$q.platform.is.mobile) this.show_message = true

                this.$axios.get(`/etraining_messages/messages/${this.id}/`, this.getHeader)
                .then(response => {
                    this.title = response.data.title
                    this.send_date = response.data.send_date
                    this.body = response.data.body
                    this.loading = false
                })
                .catch(e => {
                    this.loading = false
                    console.log(e)
                })
            }
            else {
                this.id = ''
            }
        },

        fDate(d) {
            return date.formatDate(d, 'DD/MM/YYYY HH:mm')
        },

        closeMessage() {
            this.id = ''
            this.show_message = false
        }
    },

    created() {
        this.fetchData()
    }
}
</script>

<style lang="stylus" scoped>
.selected
    font-weight bold
</style>
